<template>
  <v-card flat class="d-flex">
    <v-card flat class="pt-3">
      <v-btn icon @click="previous" :disabled="disabled">
        <v-icon>fast_rewind</v-icon>
      </v-btn>
      <v-btn v-if="!update" icon @click="play" :disabled="disabled">
        <v-icon>play_arrow</v-icon>
      </v-btn>
      <v-btn v-else icon @click="pause" :disabled="disabled">
        <v-icon>pause</v-icon>
      </v-btn>
      <v-btn icon @click="next" :disabled="disabled">
        <v-icon>fast_forward</v-icon>
      </v-btn>
    </v-card>
    <v-radio-group
      v-if="playMode"
      v-model="computedPlayMode"
      row
      dense
      :disabled="disabled || Boolean(update)"
    >
      <v-radio label="Daily" value="daily"></v-radio>
      <v-radio label="Streaming" value="streaming"></v-radio>
    </v-radio-group>
    <v-card max-width="90px" class="pt-3" flat>
      <v-select
        v-model="streamSpeed"
        label="Speed"
        :items="speedItems"
        dense
        :disabled="disabled"
      ></v-select>
    </v-card>
  </v-card>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "InputDatePlayControls",
  components: {},
  mixins: [],
  props: {
    value: { type: String, required: true },
    timeInterval: { type: Number, required: true },
    playMode: { type: String, required: false, default: null },
    disabled: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      update: null,
      streamSpeed: 1,
      speedItems: [
        { text: "0.25", value: 4 },
        { text: "0.5", value: 2 },
        { text: "0.75", value: 1.33 },
        { text: "Normal", value: 1 },
        { text: "1.25", value: 0.8 },
        { text: "1.5", value: 0.75 },
        { text: "2", value: 0.5 },
      ],
    };
  },
  computed: {
    computedPlayMode: {
      get() {
        return this.playMode;
      },
      set(val) {
        this.$emit("update:playMode", val);
        if (val === "streaming") {
          this.$emit("input", DateTime.fromISO(this.value).toISO({ includeOffset: false }));
        } else {
          this.$emit("input", DateTime.fromISO(this.value).toISODate());
        }
      },
    },
    interval() {
      return (this.playMode === "streaming" ? 0.5 : 2) * this.streamSpeed;
    },
  },
  watch: {
    disabled(val) {
      if (val && this.update) {
        clearTimeout(this.update);
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearTimeout(this.update);
  },
  destroyed() {},
  methods: {
    next() {
      if (this.playMode === "streaming") {
        this.$emit(
          "input",
          DateTime.fromISO(this.value)
            .plus({ minutes: this.timeInterval })
            .toISO({ includeOffset: false })
        );
      } else {
        this.$emit("input", DateTime.fromISO(this.value).plus({ days: 1 }).toISODate());
      }
    },
    previous() {
      if (this.playMode === "streaming") {
        this.$emit(
          "input",
          DateTime.fromISO(this.value)
            .plus({ minutes: -this.timeInterval })
            .toISO({ includeOffset: false })
        );
      } else {
        this.$emit("input", DateTime.fromISO(this.value).plus({ days: -1 }).toISODate());
      }
    },
    pause() {
      clearTimeout(this.update);
      this.update = null;
    },
    play() {
      this.next();
      this.update = setTimeout(this.play, this.interval * 1000);
    },
  },
};
</script>

<style></style>
